import { Card, styled, cardContentClasses } from '@mui/material';

export const FixedCard = styled(Card)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',

  [`> .${cardContentClasses.root}`]: {
    flexGrow: 1,
  },

  [theme.breakpoints.up('md')]: {
    width: 400,
    minHeight: 600,
  },
}));
